import { useQuery } from "@tanstack/react-query";
import { getCriteriaGroup } from "../../services/criteriaGroup";
import { useParams } from "react-router-dom";


const useGetCriteriaGroup = () => {
    const params = useParams();

    return useQuery({
        queryKey: ["criteria-groups"],
        queryFn: () => getCriteriaGroup(params?.questcode === ':questcode' ? 'MAIN-QUESTIONNAIRE' : params?.questcode ?? ''),
        staleTime: Infinity,
    });
}

export default useGetCriteriaGroup;